import {
  AutoComplete, Form, Input,
} from 'antd';
import useMailMergeFields from 'automations/hooks/useMailMergeFields';
import { filterMailMergeOptions, getMailMergeValue } from 'crm-atoms/utils';
import { useCallback } from 'react';

import FormItemTitle from './FormItemTitle';

export default function AddDescriptionForm() {
  const {
    options: mailMergeOptions,
  } = useMailMergeFields({});

  const form = Form.useFormInstance();
  const descriptionText = Form.useWatch('description', form) ?? '';
  const showOptions = descriptionText.includes('@');
  const searchString = descriptionText.slice(descriptionText.lastIndexOf('@') + 1);
  const filteredOptions = filterMailMergeOptions(mailMergeOptions, searchString);

  const handleSelect = useCallback((newValue: string) => {
    form.setFieldValue(
      'description',
      descriptionText.slice(0, descriptionText.lastIndexOf('@')) + getMailMergeValue(newValue),
    );
  }, [descriptionText, form]);

  return (
    <Form.Item
      name="description"
      label={<FormItemTitle>Description</FormItemTitle>}
      rules={[{ required: true }, { min: 1, message: 'Description is required' }]}
    >
      <AutoComplete
        options={showOptions ? filteredOptions : []}
        onSelect={handleSelect}
      >
        <Input placeholder="Add Description, Use @ to add mail merge field" />
      </AutoComplete>
    </Form.Item>
  );
}
